export const logout = () => {
    localStorage.removeItem('roles')
    localStorage.removeItem('userId')
    localStorage.removeItem('sm-token')
    localStorage.removeItem('fullName')
    localStorage.removeItem('userProfile')
    window.location.replace('/login')
}
export const removeTokens = () => {
    localStorage.removeItem('roles')
    localStorage.removeItem('userId')
    localStorage.removeItem('sm-token')
    localStorage.removeItem('fullName')
    localStorage.removeItem('userProfile')
}
export const findIndex = (id, arr) => {
    return arr.findIndex(elem => elem?.id == id);
}

export const randomPasswordGenerator = () => {
    let chars = "0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let passwordLength = 6;
    let password = "";
    for (let i = 0; i <= passwordLength; i++) {
        let randomNumber = Math.floor(Math.random() * chars.length);
        password += chars.substring(randomNumber, randomNumber + 1);
    }
    return password;
}

export const downloadFile = ({ data, fileName, fileType }) => {
    // Create a blob with the data we want to download as a file
    const blob = new Blob([data], { type: fileType })
    // Create an anchor element and dispatch a click event on it
    // to trigger a download
    const a = document.createElement('a')
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
}

export const EmailEncryption = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isEmailValid = regex.test(email);

    const encryptedEmail = isEmailValid
        ? email.replace(/^(.)(.*)(?=@)/, function (g1, g2, g3) {
            return g2 + "*".repeat(g3.length);
        })
        : "Invalid email format";

    return encryptedEmail;

};
export const maskPhoneNumber = (phoneNumber) => {
    if (phoneNumber) {
        const maskedNumber = phoneNumber.replace(
            /(\d{3})(\d{4})(\d{3})/,
            (_, first, middle, last) => `${first}${'*'.repeat(middle.length)}${last}`
        );
        return maskedNumber;
    }
    return phoneNumber
}

export function jsonToTsv(json) {
    const header = Object.keys(json).join('\t');
    const rows = Object.values(json).map(row => {
        return Object.values(row).map(val => {
            return (val === null || val === undefined) ? '' : val.toString();
        }).join('\t');
    }).join('\n');

    return `${header}\n${rows}`;
}

export const downloadCsv = (objArray) => {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let line = '';

    for (let i = 0; i < array.length; i++) {
        const header = Object.keys(array[i]);
        if (i == 0) {
            line += header.join(',') + '\r\n';
        }

        let valueLine = '';
        for (let j = 0; j < header.length; j++) {
            if (j > 0) {
                valueLine += ',';
            }

            const val = array[i][header[j]];
            if (val !== null && typeof val === 'object') {
                valueLine += JSON.stringify(val);
            } else {
                valueLine += val;
            }
        }

        line += valueLine + '\r\n';
    }

    const csvContent = 'data:text/csv;charset=utf-8,' + line.join('\n');
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'data.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const darkenColor = (hex) => {
    let hexColor = hex
    if (hex?.includes("linear-gradient"))
        hexColor = hex.split(",")[1]?.split(",")[0]?.split(" ")[1]

    // Convert hex color to RGB format
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);

    // Calculate 20% darker shades
    const darkerR = Math.max(0, Math.floor(r * 0.5));
    const darkerG = Math.max(0, Math.floor(g * 0.5));
    const darkerB = Math.max(0, Math.floor(b * 0.5));

    // Convert back to hex format
    const darkerHex = `#${darkerR.toString(16).padStart(2, '0')}${darkerG.toString(16).padStart(2, '0')}${darkerB.toString(16).padStart(2, '0')}`;

    return darkerHex;
}
export const getContrastColor = (hex) => {
    let hexColor = hex
    if (hex?.includes("linear-gradient"))
        hexColor = hex.split(",")[1].split(",")[0].split(" ")[1]
    // Convert hex color to RGB format
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);

    // Calculate relative luminance using the formula
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // Decide whether to use black or white text color based on contrast ratio
    return luminance > 0.5 ? '#000000' : '#ffffff';
}


export const EncodeURL = (text) => {
    return window.btoa(text);

}

export const DecodeURL = (base64) => {
    return window.atob(base64);
}